import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';

/* Actions */
import * as userAdminActions from '../../actions/userAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';
import * as polynomialAdminActions from '../../actions/polynomialAdmin/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/userAdmin/formPopup';
import EntityImportFormPopup from '../../components/common/entity/entityImportFormPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';

import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  confirmUserConfirmPopup: "confirmUserConfirmPopup",
  formPopup: "formPopup",
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class UserAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.userList,
      entityApiKey: "user",
      initialNewEntity: { groups: [], models_list: [], role: Constants.app.userRoles.USER },
      formHasChanges: false,
      polynomialQueryParams: {
        mini_list_version: true, 
        order_fields: ["name"],
        order_directions: [Constants.crudGenerator.orderTypes.ASC],
        fields_are: ["active", "model"],
        searches_are: [true, true],
        per_page: Constants.interface.fullListPageSize
      },
    };
  }
 
  componentDidMount() {
    EntityTableTooling.fetchList(this);
    this.props.actions.getGroupsList();
    this.props.polynomialActions.getList(this.state.polynomialQueryParams);
    this.props.actions.getBiTemplatesList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }

  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "userAdmin.entityNameSingularWithArticle"})),
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "userAdmin.entityNamePlural"})),
      intl.formatMessage({id: "userAdmin.genderVocal"}),
      (this.props.delete.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.delete.errors.message : ""));
      
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.confirmUser.status],
      [this.props.confirmUser.status],
      intl.formatMessage({id: "userAdmin.confirmUserSuccess"}),
      intl.formatMessage({id: "userAdmin.confirmUserError"}),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.confirmUserConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.confirmUserConfirmPopup, this.setState.bind(this));
        }
        this.props.actions.setSaveEntityDataByKey("user.is_active", true);
        EntityTableTooling.fetchList(this);
      }]
    );
  }

  handleOnChangeForm = (event) => {
    if(event.currentTarget.dataset.path==="user.models_list") { 
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = JSON.parse(event.currentTarget.dataset.value);
      let isDelete = event.currentTarget.dataset.delete;
      let isEdit = event.currentTarget.dataset.edit;
      let objectDefinition = [];

      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      
      if(isDelete) { 
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } else if(isEdit) {
        objectDefinition[index] = objectValue;
      } else {
        objectDefinition.push(objectValue);
      }
      this.props.actions.setSaveEntityDataByKey(path, objectDefinition); 
      this.setState({ formHasChanges: true });  
    }
    else if(event.currentTarget.dataset.selectlist) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;

      let list = JavascriptUtilsTooling.deepCopy(
        (JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path) || [])
      );

      if(path==="user.groups") {
        if(isDelete) { 
          delete list[index];
          list = list.filter(item => item);
        } else {
          list.push({id: listValue, name: (this.props.groupsData.data.find(item => item.id==listValue)).name });
        }
        this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path, list);
      }
      else{
        if(isDelete) { 
          delete list[index];
          list = list.filter(item => item);
        } else {
          list.push({id: listValue, name: (this.props.polynomialsList.data.find(item => item.id==listValue)).name });
        }
        this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path, list);      
      }
      this.setState({ formHasChanges: true });            
    }
    else {
      EntityTableTooling.handleOnChangeForm(this, event);
    }    
  };

  handleConfirmUserManually = async () => {
    await this.props.actions.confirmUser({
      id: JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "user.id")
    });    
  };

  handleShowConfirmUserConfirmPopup = (event) => {    
    InterfaceTooling.handleShowPopup(
      event, popupIds.confirmUserConfirmPopup, this.state, 
      this.setState.bind(this), this.props.confirmUser.loading, () => { });
  }

  render() {
    var loadingView = this.props.list.firstLoading || this.props.polynomialsList.firstLoading || this.props.biTemplatesList.firstLoading;
    var errorLoadingView = this.props.list.status !== null && this.props.list.status !== 200;
    return (
      <section className="dashboard_content_inner_view entity_admin_container user_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleImportFormPopup={EntityTableTooling.handleShowImportFormPopup.bind(null, this)}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
              />
              <FormPopup
                handleShowPopup={EntityTableTooling.handleShowFormPopupWithConfirmOnExit.bind(null, this)}
                handleOnChangeForm={this.handleOnChangeForm}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                handleConfirmButton={this.handleShowConfirmUserConfirmPopup}
                loadingAlternativeButton={this.props.confirmUser.loading}
                fullLoading={this.props.save.loading}
                statusButton={this.props.save.status}
                formData={this.props.save.data}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                popupState={EntityTableTooling.getFormPopupState(this)}
                groupsData={this.props.groupsData.data}
                polynomialData={this.props.polynomialsList.data}
                biTemplatesData={this.props.biTemplatesList.data}
                userProfile={this.props.userProfile.data}
              />
              <EntityImportFormPopup
                handleShowPopup={EntityTableTooling.handleShowImportFormPopup.bind(null, this)}
                handleDownloadImportSheet={EntityTableTooling.handleDownloadImportSheet.bind(null, this)}
                handleButton={EntityTableTooling.handleOnSaveImportForm.bind(null, this)}
                loadingButton={this.props.import.loading}
                fullLoading={this.props.import.loading || this.props.downloadImport.loading}
                statusButton={this.props.import.status}
                errors={this.props.import.errors}
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                genderVocal={this.state.tableDescriptor.genderVocal}
                popupState={EntityTableTooling.getImportPopupState(this)}
                additionalControls={!this.props.userProfile.data.customer_is_single_sign_on ? null : (
                  <label className="form_info">
                    <FormattedMessage id={"userAdmin.importHelpWithSSO"}/>
                    <p></p>
                  </label>
                )}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (<FormattedMessage id={"userAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (<FormattedMessage id={"userAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"userAdmin.entityNameSingular"}/>),
                    activeAction: this.props.save.data.user && this.props.save.data.user.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"userAdmin.entityNameSingularWithArticle"}/>),
                    activeAction: this.props.save.data.user && this.props.save.data.user.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"userAdmin.confirmUserConfirmPopupTitle"}
                />)}
                confirmText={(<FormattedMessage 
                 id={"userAdmin.confirmUserConfirmPopup"}
                />)}
                handleConfirm={this.handleConfirmUserManually}
                handleCancel={this.handleShowConfirmUserConfirmPopup}
                popupState={this.state[popupIds.confirmUserConfirmPopup]}
                loading={this.props.confirmUser.loading}
              />
              <GlassConfirmPopup              
                confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.userAdmin.list,
  save: state.reducer.userAdmin.save,
  delete: state.reducer.userAdmin.delete,
  import: state.reducer.userAdmin.import,
  downloadImport: state.reducer.userAdmin.downloadImport,
  groupsData: state.reducer.userAdmin.groupsData,
  confirmUser: state.reducer.userAdmin.confirmUser,
  biTemplatesList: state.reducer.userAdmin.biTemplatesList,
  polynomialsList: state.reducer.polynomialAdmin.list,
  userProfile: state.reducer.dashboard.userProfile
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(userAdminActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  polynomialActions: bindActionCreators(polynomialAdminActions, dispatch),
});

UserAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/userAdmin/index.jsx